import React from 'react'
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import BarLoader from "react-spinners/BarLoader";
import logo from './img/logo.png';
import Main from './components/main/Main'
import 'bootstrap/dist/css/bootstrap.min.css'
import Header from './components/header/Header'
import Footer from './components/footer/Footer'
import Project1 from './components/main/ourProjects/Project1'
import Project2 from './components/main/ourProjects/Project2';
import Project3 from './components/main/ourProjects/Project3';
import Project4 from './components/main/ourProjects/Project4';
import Project5 from './components/main/ourProjects/Project5';
import Project6 from './components/main/ourProjects/Project6';
import './components/loaging/loading.css'


export const App = () => {

  const [loading, setLoading] = useState(false)
  useEffect(() => {

    setLoading(true)
    setTimeout(() => {
      setLoading(false)

    }, 1000)

  }, [])




  return (
    loading ?
      <div className='loading'>
        <img className='img-carga' src={logo} />
        <BarLoader

          color={'#ba9f4e'}
          loading={loading}
          size={50}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
      :

      <>




        <Header />
        <Router>
          <Routes>

            <Route exact path='/' Component={Main} />
            <Route exact path='/Project1' Component={Project1} />
            <Route exact path='/Project2' Component={Project2} />
            <Route exact path='/Project3' Component={Project3} />
            <Route exact path='/Project4' Component={Project4} />
            <Route exact path='/Project5' Component={Project5} />
            <Route exact path='/Project6' Component={Project6} />


          </Routes>

        </Router>
        <Footer />
      </>

  )
}

export default App
